import type { Editor } from '@tiptap/core';
import type { MarkdownStorage } from 'tiptap-markdown';

declare module '@tiptap/core' {
  interface Storage {
    markdown: MarkdownStorage;
  }
}

export function getMarkdown(editor: Editor): string {
  return editor.storage.markdown.getMarkdown();
}
